import { generatePath, Navigate } from "react-router";

import { PATHS } from "@/routes/paths";

import { DummyRoomEditPresenter } from "./presenter";
import { useDummyRoomEditQuery } from "../../model/repository/existing";

type Props = {
	hotelID: string;
	roomID: string;
};

export const DummyRoomEditContainer = ({ hotelID, roomID }: Props) => {
	const serverModel = useDummyRoomEditQuery({ hotelID, roomID });

	if (!serverModel) {
		return <Navigate to={generatePath(PATHS.HOTEL.ITEMS.ROOM.TOP, { hotelID })} />;
	}

	return <DummyRoomEditPresenter serverModel={serverModel} />;
};

DummyRoomEditContainer.displayName = "DummyRoomEditContainer";
